import { Fragment } from "react";
import { Picture } from "@/components/Picture";
import { Markdown } from "@/components/Markdown";

export const Footer = ({ settings }) => {
  if (!settings) return null;
  const socials = (settings.socials || []).filter((s) => s.label?.trim() && s.url?.trim());
  const lines = settings.address_lines || [];
  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="wrap">
        <div>
          <Picture src="/assets/img/logo-gold.png" alt="Nepal Food" lazy />
          <p>
            <strong style={{ color: "#fff" }}>Nepal Food Networks</strong>
          </p>
          <p>A not-for-profit company registered in Nepal, 2020.</p>
        </div>
        <div>
          <h3>Contact</h3>
          <p data-testid="footer-address">
            {lines.map((l, i) => (
              <Fragment key={i}>
                {i > 0 && <br />}
                {l}
              </Fragment>
            ))}
          </p>
          <p>
            <a href={`mailto:${settings.contact_email}`} data-testid="footer-email-link">
              {settings.contact_email}
            </a>
          </p>
        </div>
        {socials.length > 0 && (
          <div>
            <h3>Follow</h3>
            {socials.map((s) => (
              <p key={s.label + s.url}>
                <a href={s.url} rel="noopener" data-testid={`footer-social-${s.label.toLowerCase()}`}>
                  {s.label}
                </a>
              </p>
            ))}
          </div>
        )}
        <div className="fine" data-testid="footer-credit">
          <Markdown text={settings.footer_credit} />
        </div>
      </div>
    </footer>
  );
};
